import { addUFOCustomData } from "@atlaskit/react-ufo/custom-data";
import { CustomData } from "@atlaskit/react-ufo/interaction-metrics";
import { setInteractionError } from "@atlaskit/react-ufo/set-interaction-error";
import traceUFOPress from "@atlaskit/react-ufo/trace-press";
export class SignupReactUFO {
    private readonly name: string;
    private customData: CustomData;
    public constructor(name: string) {
        this.name = name;
        this.customData = {};
    }

    public complete() {
        traceUFOPress(this.name);
        addUFOCustomData(this.customData);
    }

    public addCustomData(data: CustomData): void {
        this.customData = {
            ...this.customData,
            ...data
        };
    }

    public error(options: { errorName: string; errorMessage: string }) {
        const { errorName, errorMessage } = options;
        this.complete();
        setInteractionError(this.name, { errorMessage, name: errorName });
    }
}
